module.exports = __webpack_public_path__ + "img/1503998177.5a0774c7.jpg";